export default __webpack_public_path__ + "static/media/close-button-icon.2c194867.svg";